import styled from 'styled-components';

import { customScrollMinimal } from '~/components/custom-scroll/CustomScroll.styles';
import { HeaderLogotype } from '~/components/header-navigation/components/header-logotype/HeaderLogotype';
import { breakpoints } from '~/design-tokens/breakpoints/breakpoints';
import { timingFunction } from '~/utils/transitions';

import { MainLabel } from './components/nav-item/NavItem.styles';

export const LogoButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  background-color: transparent;
  padding: 0;
`;

export const Header = styled.header`
  position: sticky;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--border-soft);
  height: var(--app-header-height);
  padding: 12px 20px;
  background-color: var(--background-soft);
`;

export const StyledLogotype = styled(HeaderLogotype)`
  transition: transform 300ms ${timingFunction.base};

  img {
    transition: opacity 300ms ${timingFunction.base};
  }

  transform: translateX(-43px);

  @media ${breakpoints.xl} {
    transform: translateX(0);
  }
`;

export const Categories = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 12px 0px 12px 0;
  gap: 16px;
  overflow-x: clip;

  overflow-y: auto;
  ${customScrollMinimal};

  ${MainLabel} {
    transition: opacity 0.3s ${timingFunction.base};
    opacity: 1;
  }
`;
